module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_13.abc1470c.jpg";